import { render, staticRenderFns } from "./exchangeFinished.vue?vue&type=template&id=5978cf45&scoped=true&"
import script from "./exchangeFinished.vue?vue&type=script&lang=js&"
export * from "./exchangeFinished.vue?vue&type=script&lang=js&"
import style0 from "./exchangeFinished.vue?vue&type=style&index=0&id=5978cf45&prod&lang=less&scoped=true&"
import style1 from "./exchangeFinished.vue?vue&type=style&index=1&id=5978cf45&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978cf45",
  null
  
)

export default component.exports